import { render, staticRenderFns } from "./region-villages-tree.vue?vue&type=template&id=5a49b8b2&scoped=true&"
import script from "./region-villages-tree.vue?vue&type=script&lang=js&"
export * from "./region-villages-tree.vue?vue&type=script&lang=js&"
import style0 from "./region-villages-tree.vue?vue&type=style&index=0&id=5a49b8b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49b8b2",
  null
  
)

export default component.exports